import React from "react"
import SEO from "../components/seo"
import UspBand from "../components/uspBand/uspBand"
import QuoteBuilder from "../components/form/quoteBuilder"
import Process from "../components/process/process"
import Reviews from "../components/reviews/reviews"
import AirResultsPanel from "../components/airResultsPanel/airResultsPanel"
import HighSpendCaseStudies from "../components/highSpendCaseStudies/highSpendCaseStudies"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faTags, faThermometerHalf, faChartLine, faChartArea, faMapMarkerAlt } from "@fortawesome/free-solid-svg-icons"
import { graphql, Link } from "gatsby"
import Img from "gatsby-image"

const USP_BLOCK_ICONS = {
  tags: faTags,
  "thermometer-half": faThermometerHalf,
  "chart-line": faChartLine,
  "chart-area": faChartArea,
  "map-marker-alt": faMapMarkerAlt,
}

const DigitalServiceHighSpendPage = ({ data: { service, shared }, location }) => {
  return (
    <>
      <SEO
        titleOverride={service.metaTags && service.metaTags.title ? service.metaTags.title : service.title}
        descriptionOverride={service.metaTags && service.metaTags.description ? service.metaTags.description : null}
        pathnameOverride={location.pathname}
        imageOverride={service.metaTags && service.metaTags.image ? service.metaTags.image.url : null}
        noIndex={service.ppcOnlyPage ? true : false}
      />

      <section className="mb-12">
        <div className="container">
          <div className="w-full mx-auto md:w-10/12">
            <div className="w-full mx-auto text-center md:w-9/12 lg:w-7/12">
              <ol className="block mb-1">
                <li className="text-base text-grey-dark">
                  <Link to="/services/" className="text-base underline transition duration-500 ease-in-out text-grey-dark hover:text-secondary-dark focus:text-secondary-dark">
                    <span>Digital</span>
                  </Link>
                  {service.title ? ` / ${service.title}` : " /"}
                </li>
              </ol>

              <span className="block h1">{ service.heroHeading }</span>
              <div className="content content--reset" dangerouslySetInnerHTML={{ __html: service.heroExcerpt }}></div>
            </div>
          </div>
        </div>
      </section>

      { service.showQuoteBuilderForm ? (
        <section className="mb-16 lg:mb-24">
          <p className="px-12 mb-8 text-xl leading-tight text-center align-middle lg:text-2xl font-display md:px-24">Get in touch today on <a href="tel:01159598900" className="inline-block break-all transition duration-500 ease-in-out text-primary hover:text-primary-dark focus:text-primary-dark contactlink">0115 959 8900</a> or <span className="block mt-3 ml-2 align-middle sm:mt-0 sm:inline-block"><a href="#quote" className="text-base capitalize btn btn--outline">Get a quote online</a></span></p>
        </section>
      ) : (
        <section className="mb-16 lg:mb-24">
          <p className="px-12 mb-8 text-xl leading-tight text-center align-middle lg:text-2xl font-display md:px-24">Get in touch today on <a href="tel:01159598900" className="inline-block break-all transition duration-500 ease-in-out text-primary hover:text-primary-dark focus:text-primary-dark contactlink">0115 959 8900</a> or <span className="block mt-3 ml-2 align-middle sm:mt-0 sm:inline-block"><a href="#form" className="text-base capitalize btn btn--outline">Get in touch</a></span></p>
        </section>
      )}

      <div className="container flex flex-wrap items-center justify-center py-4 mb-6 md:md:items-stretch lg:mb-24">
        <div className="flex flex-wrap justify-center md:w-full md:justify-between md:-mx-2">
          <div className="w-1/3 lg:w-1/5 p-1 md:p-4 flex">
            <div className="flex flex-wrap items-center justify-start w-full p-0 border-2 outline-none md:p-6 border-grey">
              <div className="w-full m-auto md:px-2">
                <div className="m-auto text-center gatsby-image-wrapper ">
                  <Img fluid={shared.agencyAwardLogo.fluid} className="w-full" />
                </div>
              </div>
            </div>
          </div>
          <div className="w-1/3 lg:w-1/5 p-1 md:p-4 flex">
            <div className="flex flex-wrap items-center justify-start w-full p-0 border-2 outline-none md:p-6 border-grey">
              <div className="w-full m-auto md:px-2">
                <div className="m-auto text-center gatsby-image-wrapper">
                  <Img fluid={shared.awardLogo.fluid} className="w-full" />
                </div>
              </div>
            </div>
          </div>
          <div className="w-1/3 lg:w-1/5 p-1 md:p-4 flex">
            <div className="flex flex-wrap items-center justify-start w-full p-0 border-2 outline-none md:p-6 border-grey">
              <div className="w-full m-auto md:px-2 py-4 md:py-0">
                <div className="m-auto text-center gatsby-image-wrapper">
                  <Img fluid={shared.bingAccreditedLogo.fluid} className="w-full mb-4" />
                </div>
              </div>
            </div>
          </div>
          <div className="w-1/3 lg:w-1/5 p-1 md:p-4 flex">
            <div className="flex flex-wrap items-center justify-start w-full p-0 border-2 outline-none md:p-6 border-grey">
              <div className="w-full m-auto md:px-2 py-4 md:py-0">
                <div className="m-auto text-center gatsby-image-wrapper">
                  <a href="https://www.google.com/partners/agency?id=5691807449" target="_blank" rel="noreferrer" className="flex justify-center">
                    <img src={shared.googlePartner.url} alt="Google Partner" className="w-full" />
                  </a>
                </div>
              </div>
            </div>
          </div>
          <div className="w-full lg:w-1/5 p-4 flex">
            <div className="flex flex-wrap items-center justify-center w-full p-6 border-2 outline-none border-grey">
              <div className="w-full md:w-auto md:px-2">
                <div className="w-56 mx-auto text-center">
                  <Reviews hideExtraText />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {service.stats && service.stats.length > 1 ? (
        <section className="z-10 pb-12 overflow-hidden lg:pb-16 border-grey">
          <div className="container">
            <h2 className="text-center">[Headline stats]</h2>
            <div className="flex flex-wrap md:-mx-2">
              {service.stats.map(({ heading, text }, index) => {
                return(
                  <div className="w-full mb-6 text-center md:w-1/4 md:mb-0 md:px-2" key={index}>
                    <span className="flex items-center justify-center w-40 h-40 mx-auto mb-6 text-5xl text-white rounded-full font-display bg-secondary-dark">{ heading }</span>
                    <span className="block text-xl xl:text-2xl lg:px-2 xl:px-4" dangerouslySetInnerHTML={{ __html: text }}></span>
                  </div>
                )
              })}
            </div>
          </div>
        </section>
      ) : null}

      { service.usps && service.usps.length ? (
        <UspBand
          usps={service.usps.map((usp) => ({
            ...usp,
            blurb: usp.blurb || "",
          }))}
        />
      ) : (
        <></>
      )}

      <HighSpendCaseStudies />

      <section className="relative z-10 mb-16 overflow-hidden lg:mb-20">
        <div className="container">
          <div className="flex flex-wrap lg:-mx-12 xl:items-center">
            <div className="w-full mb-5 lg:w-1/2 xl:w-5/12 lg:px-12 lg:mb-0">
              {service.brandLogo && (
                <Img fluid={service.brandLogo.fixed} className="w-48 mb-3" />
              )}
              <div className="w-full content content--reset lg:pr-12 xl:pr-0" dangerouslySetInnerHTML={{ __html: service.content }}></div>
            </div>
            {service.contentImage && (
              <div className="w-full ml-auto lg:w-1/2 lg:px-12">
                <Img
                  backgroundColor={`#3B5CC4`}
                  fluid={service.contentImage.fluid}
                />
              </div>
            )}
          </div>
        </div>
      </section>

      { service.reportingBackgroundImage ? (
        <div className="overflow-hidden bg-secondary">
          <div className="container pt-12 pb-8 md:pt-16 md:pb-10">
            <AirResultsPanel />
          </div>
          <div className="relative">
            <div className="absolute top-0 right-0 z-10 hidden lg:-mr-48 xl:mr-0 reporting-img lg:block">
              <Img fluid={service.reportingBackgroundImage.fixed} className="w-auto" />
            </div>
            <div className="container relative flex flex-wrap items-center">
              <div className="w-full py-10 text-white h3 lg:w-1/2 reporting-text lg:py-16" dangerouslySetInnerHTML={{ __html: service.reportingText }}></div>
            </div>
            { service.reportingBackgroundImageMobile ? (
              <div className="bottom-0 right-0 z-10 block w-full md:-mb-36 lg:hidden reporting-img">
                <Img fluid={service.reportingBackgroundImageMobile.fixed} className="w-auto" />
              </div>
            ) : ( <></> )}
          </div>
        </div>
      ) : ( <></> )}

      { service.uspsBlock && service.uspsBlock.length ? (
        <section className="py-12 overflow-hidden text-white bg-secondary-dark md:py-20 xl:py-24">
          <div className="container">
            <div className="w-11/12 mx-auto">
              <h2 className="mb-12 text-center text-secondary-light md:mb-20 xl:mb-24">{ service.uspsBlockHeading || "[Air features]" }</h2>

              <div className="flex flex-wrap md:-mx-8">
                {service.uspsBlock.map(({icon, heading, text}, i) => {
                  const iconDefinition = icon ? USP_BLOCK_ICONS[icon] : null
                  return (
                    <div className="w-full mb-16 md:w-1/2 md:mb-24 md:px-8" key={i}>
                      <div className="relative px-8 border-l border-opacity-25 border-secondary-light md:px-12">
                      <div className="absolute top-0 left-0 w-px h-4 -ml-px bg-primary"></div>
                        { iconDefinition && (
                          <div className="flex items-center justify-center w-8 h-8 mb-4 rounded-full md:w-10 md:h-10 bg-primary text-secondary-dark">
                            <FontAwesomeIcon className="inline-block w-3 h-4 text-sm md:text-base" icon={ iconDefinition } size="sm" />
                          </div>
                        )}
                        { heading && (
                          <h4 className="text-primary">{ heading }</h4>
                        )}
                        { text && (
                          <div className="content content--primary-list content--nofirst content--primary-links" dangerouslySetInnerHTML={{ __html: text }}></div>
                        )}
                      </div>
                    </div>
                  )
                })}
              </div>
            </div>
          </div>
        </section>
      ) : (
        <></>
      )}

      { service.extraContentCopy ? (
        <section className="relative z-10 pt-12 pb-12 overflow-hidden high-spend-extra-content md:pt-16 md:pb-16 bg-grey-light">
          <div className="container">
            <div className="w-full md:w-11/12">
              <div className="flex flex-wrap">
                <div className="w-full mb-5 md:w-8/12 lg:mb-0">
                  <div className="w-full content content--reset lg:pr-12 xl:pr-0" dangerouslySetInnerHTML={{ __html: service.extraContentCopy }}></div>
                </div>
              </div>
            </div>
          </div>
        </section>
      ) : (
        <></>
      )}

      <Process />

      { service.additionalContentHeading ? (
        <section className="py-12 overflow-hidden border-b high-spend-additional-content md:py-16 xl:py-20 border-grey-light">
          <div className="container">
            <div className="w-full mx-auto md:w-11/12">
              <div className="flex flex-wrap mb-8 md:mb-12 xl:mb-16 md:-mx-6 lg:-mx-12">
                <div className="w-full mb-8 md:w-1/2 md:px-6 lg:px-12 md:mb-0">
                  {service.additionalContentImage && (
                    <div className="w-full">
                      <Img
                        backgroundColor={`#3B5CC4`}
                        fluid={service.additionalContentImage.fluid}
                      />
                    </div>
                  )}
                  {service.additionalContentImageTwo && (
                    <div className="w-full mt-6 hidden md:block">
                      <Img
                        backgroundColor={`#3B5CC4`}
                        fluid={service.additionalContentImageTwo.fluid}
                      />
                    </div>
                  )}
                </div>
                <div className="w-full md:w-1/2 md:px-6 lg:px-12">
                  <div className="mb-8 md:mb-12">
                    <h2>{ service.additionalContentHeading }</h2>
                  </div>

                  <div className="content content--primary-list" dangerouslySetInnerHTML={{ __html: service.additionalContentText }}>
                  </div>
                </div>
              </div>

              <p className="pb-0 mb-0 text-center align-middle text-secondary-dark font-display h3">Get in touch today on <a href="tel:01159598900" className="inline-block break-all transition duration-500 ease-in-out text-primary hover:text-primary-dark focus:text-primary-dark contactlink">0115 959 8900</a> or <span className="ml-2 align-middle"><Link to="/contact/" className="text-base btn btn--primary">Contact Us</Link></span></p>
            </div>
          </div>
        </section>
      ) : (
        <></>
      )}

      <section className="py-12 md:py-16">
        <div className="container">
          <div className="w-56 mx-auto text-center">
            <Reviews />
          </div>
        </div>
      </section>

      { service.showQuoteBuilderForm && (
        <QuoteBuilder />
      )}
    </>
  )
}

export default DigitalServiceHighSpendPage

export const query = graphql`
  query DigitalServiceHighSpend($slug: String!) {
    shared: datoCmsShared {
      awardLogo {
        fluid(
          maxWidth: 400
          imgixParams: {h: "814", w: "300"}) {
          ...GatsbyDatoCmsFluid_noBase64
        }
      },
      agencyAwardLogo {
        fluid(
          maxWidth: 400
          imgixParams: {h: "814", w: "300"}) {
          ...GatsbyDatoCmsFluid_noBase64
        }
      },
      googlePartner {
        url
      },
      bingAccreditedLogo {
        fluid(
          maxWidth: 400
          imgixParams: {h: "814", w: "300"}) {
          ...GatsbyDatoCmsFluid_noBase64
        }
      },
    },
    service: datoCmsService(slug: { eq: $slug }) {
      slug
      ppcOnlyPage
      showQuoteBuilderForm
      stats {
        heading
        text
      }
      treeParent {
        slug
      }
      metaTags {
        title
        description
        twitterCard
        image {
          url
        }
      }
      brandLogo {
        fixed(width: 500, height: 200) {
          ...GatsbyDatoCmsFixed
        }
      }
      usps {
        heading
        blurb
      }
      uspsBlockHeading
      uspsBlock {
        heading
        icon
        text
      }
      reportingText
      reportingBackgroundImage {
        fixed(width: 900, height: 900) {
          ...GatsbyDatoCmsFixed
        }
      }
      reportingBackgroundImageMobile {
        fixed(width: 1024, height: 800) {
          ...GatsbyDatoCmsFixed
        }
      }
      extraContentCopy
      faqsHeading
      faqsBlurb
      faqsSuppressSchema
      faqs {
        question
        answer
      }
      additionalContentHeading
      additionalContentText
      additionalContentImage {
        fluid(
          maxWidth: 720
          imgixParams: {h: "720", w: "720", fit: "crop", crop: "faces, edges"}) {
          ...GatsbyDatoCmsFluid
        }
      }
      additionalContentImageTwo {
        fluid(
          maxWidth: 720
          imgixParams: {h: "720", w: "720", fit: "crop", crop: "faces, edges"}) {
          ...GatsbyDatoCmsFluid
        }
      }
      title
      heroHeading
      heroExcerpt
      content
      contentImage {
        fluid(
          maxWidth: 720
          imgixParams: {h: "720", w: "720", fit: "crop", crop: "faces, edges"}) {
          ...GatsbyDatoCmsFluid
        }
      }
    }
  }
`
